import { useAtom } from 'jotai';
import React, { useEffect, useState } from 'react';
import { aemContent, aemDisclosureItems } from '../../state/globalState';
import { Mode, ThemeName, ThemeProvider } from '@fcamna/shared-component-foundations';
import styles from './Disclosure.module.scss';
import { htmlReactParserWrapper } from '../../utils/htmlReactParserWrapper';
import { TextDisclosure } from '@fcamna/react-library';

interface DisclosureItem {
    text: React.ReactNode;
    disclosureNumber: number;
    onClick?: () => void;
    returnToLinkTitle?: string;
}

const Disclosure: React.FC = () => {
    const [aem] = useAtom(aemContent);
    const [aemDisclosuresItems] = useAtom(aemDisclosureItems);
    const [disclosureItemsList, setDisclosureItemsList] = useState<DisclosureItem[]>([]);
    const disclosureTitle = aem?.['disclosure-container']?.['props']?.['headline'] || '';
    const globalDisclosureItemKeys: number[] = [];
    const globalDisclosures = aem?.['disclosure-container']?.['props']?.['disclosures'] || [];

    useEffect(() => {
        if (aem && (aemDisclosuresItems as Map<number, Disclosures>) && aemDisclosuresItems.size > 0) {
            const scrollableDisclosureItems: DisclosureItem[] = [];
            aemDisclosuresItems.forEach((disclosure: any, disclosureKey: number) => {
                if (!disclosure.isGlobalDisclosure) {
                    scrollableDisclosureItems.push({
                        text: htmlReactParserWrapper(disclosure.disclosureText),
                        onClick: () => {
                            const disclosureElement = document.getElementsByClassName(`disclosure-super-script-link-${disclosure.disclosureNumber}`);
                            if (disclosureElement && disclosureElement.length > 0) {
                                const elementPosition = disclosureElement[disclosureElement.length - 1].getBoundingClientRect().top;
                                const offsetPosition = elementPosition + window.pageYOffset - 210;
                                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                            }
                        },
                        returnToLinkTitle: 'Return to content',
                    });
                } else {
                    globalDisclosureItemKeys.push(disclosureKey);
                }
            });

            scrollableDisclosureItems.sort((a: DisclosureItem, b: DisclosureItem) => {
                const aIndex = globalDisclosureItemKeys.indexOf(a.disclosureNumber);
                const bIndex = globalDisclosureItemKeys.indexOf(b.disclosureNumber);
                return aIndex - bIndex;
            });
            setDisclosureItemsList(scrollableDisclosureItems);
        }
    }, []);

    const globalDisclosureContent = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {globalDisclosures &&
                globalDisclosures.length > 0 &&
                globalDisclosures.map((disclosure: any, key: any) => (
                    <div style={{ marginTop: '16px' }} key={key}>
                        {disclosure?.disclosure?.disclosureText.split('</p><p>').map((paragraph: string, index: number) => (
                            <div key={index}>{htmlReactParserWrapper(paragraph)}</div>
                        ))}
                    </div>
                ))}
        </div>
    );

    return (
        <>
            {disclosureTitle && (
                <div id="disclosure-1">
                    <ThemeProvider themeName={ThemeName['FORD_PRO']} mode={Mode.LIGHT_MODE}>
                        <TextDisclosure
                            titleProp={{
                                title: disclosureTitle || '',
                                headingLevel: 'h6',
                            }}
                            className={styles.disclosureWrapper}
                            disclosureItems={disclosureItemsList}
                            returnToLinkTitle="Return to content"
                            globalDisclosureContent={globalDisclosureContent}
                        />
                    </ThemeProvider>
                </div>
            )}
        </>
    );
};

export default Disclosure;
